import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from "react-router-dom"

import { DialogModal } from '../DialogModal'
import ToggleWithLabel from '../ToggleWithLabel'

import { getFilters, makeGetSalesEvent } from '../../store/Event/selector'
import { updateFilter, updateSalesEvent } from '../../store/Event/actions'
import { setCurrentPaginationPage, setScreenScrollOffset } from '../../store/AppState/actions'

const NavbarSwitches = () => {
  const [showLockEventDialog, setShowLockEventDialog] = useState(false)
  const { eventId } = useParams()
  const dispatch = useDispatch()
  const event = useSelector((state) => makeGetSalesEvent()(state, eventId))
  const showEmptySuites = useSelector((state) => getFilters(state).showEmptySuites)
  const dialogTitle = event.locked ? `Unlock event ${event.name}` : `Lock event ${event.name}`

  const handleLockEvent = () => {
    const { uuid, locked } = event
    const params = {
      uuid,
      locked: !locked
    }

    dispatch(updateSalesEvent(params))
  }

  const handleShowEmptySuites = () => {
    dispatch(updateFilter('showEmptySuites', !showEmptySuites))
    dispatch(setCurrentPaginationPage({ screen: 'eventDetails', page: 0 }))
    dispatch(setScreenScrollOffset({ screen: 'eventDetails', offset: 0 }))
  }

  return (
    <div className='event-toggle'>
      <ToggleWithLabel
        checked={showEmptySuites}
        onChange={handleShowEmptySuites}
        label="Show Empty Suites"
      />
      <ToggleWithLabel
        checked={event.locked}
        disabled={!event.allowLockToggle}
        onChange={() => setShowLockEventDialog(true)}
        label="Lock Event"
      />
      <DialogModal
        closeModalCallback={setShowLockEventDialog}
        confirmationCallback={handleLockEvent}
        modalButtonText='Yes'
        modalIsOpen={showLockEventDialog}
        modalTitle={dialogTitle}
      />
    </div>
  )
}

export default NavbarSwitches
